/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { ResultSetDependencies } from './dependenciesResultSet.generated';
import { createBlockNode } from '../../factoriesAny.js';
export var BlockNodeDependencies = {
  NodeDependencies: NodeDependencies,
  ResultSetDependencies: ResultSetDependencies,
  createBlockNode: createBlockNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesBlockNode.generated.js
// module id = 618
// module chunks = 0